/**
 * 2019-04-12
 * handan
 * 存储调查结果页信息
 */

const defaultValue = {
}

export default ( state=defaultValue, action ) => {
  switch (action.type) {
    case "setCheckedList":
      return {
        ...state,
        checkedList: action.data
      };
      break;
    case "setVerifyresult":
      return {
        ...state,
        ...action.data,
      };
      break;
    case "setVerifyDataList":
      return {
        ...state,
        verifyDataList: action.data
      };
      break;
      
    default:
      return state
      break;
  }
}